import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.table = [];
    this.cardsLayout = [
      // cards
      {
        title: "Terms",
        items: [
          {
            label: {
              value: "Order",
              size: "65px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "order"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "PO Mgmt Type",
              size: "120px",
              fontSize: "95%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "vWhsePOType"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Collect",
              size: "calc(100% - 52px)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "freightCollect"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Freight",
              size: "65px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "freight"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Console Code",
              size: "120px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "consolCode"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Active Flag",
              size: "calc(100% - 52px)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "activeFlag"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Backorder Cancel Days",
              size: "81%",
              fontSize: "90%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "bkordCancelDays"
            },
            size: "calc(100% / 3 )",
            readOnly: true
          },
          {
            label: {
              value: "PO Fill Percentage",
              size: "81%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "rrFillPercent"
            },
            size: "calc( 30% )"
          },
          {
            label: {
              value: "Agreement Lead Time",
              size: "calc(100% - 52px)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "agreemntLeadTime"
            },
            size: "calc( 36.65% )",
            readOnly: true
          },
          {
            label: {
              value: "Backhaul Flag",
              size: "120px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "backhaulFlag"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "DSD Lead Time",
              fontSize: "93%",
              size: "120px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadTimeDSD"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Input Lead Time",
              fontSize: "92%",
              size: "120px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadTimePolicy"
            },
            size: "25%"
          },
          {
            label: {
              value: "Calc Lead Time",
              size: "calc(100% - 52px)",
              fontSize: "82%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadTimeActual"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Lead Time Pad",
              size: "120px",
              fontSize: "95%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "ltPadDays"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Variability",
              size: "calc(100% - 30px)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadTimeVary"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Open on Sat",
              size: "calc(100% - 30px)",
              fontSize: "90%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "vendorOpenSat"
            },
            size: "20%",
            readOnly: true
          },
          {
            label: {
              value: "Sun",
              fontSize: "95%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "vendorOpenSun"
            },
            size: "10%",
            readOnly: true
          },
          {
            label: {
              value: "Current",
              size: "calc(100% - 75px)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pOCurrencyCode"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Logistics Export",
              size: "120px",
              fontSize: "90%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "logisticsExport"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Transit Days",
              size: "120px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "transitDays"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "FedEx Export",
              size: "120px"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "fedexExport"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Logistic Returns",
              size: "120px",
              fontSize: "90%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "logisticsReturns"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Order Days",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "OrderDays"
            },
            size: "17.5%"
          },
          {
            label: {
              value: "Mon",
              size: "55%",
              fontSize: "95%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "ordMonday"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Tue",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "ordTuesday"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Wed",
              size: "55%",
              fontSize: "90%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "ordWednesday"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Thu",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "ordThursday"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Fri",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "ordFriday"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Rvw Time",
              size: "calc(100% - 75px)",
              fontSize: "98%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "revTime"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Daily LT",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "DailyLT"
            },
            size: "17.5%"
          },
          {
            label: {
              value: "Mon",
              size: "55%",
              fontSize: "95%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadDaysMon"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Tue",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadDaysTue"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Wed",
              size: "55%",
              fontSize: "90%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadDaysWed"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Thu",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadDaysThu"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Fri",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "leadDaysFri"
            },
            size: "11.5%",
            readOnly: true
          },
          {
            label: {
              value: "Cntry",
              size: "calc(100% - 75px)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "countryCode"
            },
            size: "25%",
            readOnly: true
          }
        ]
      },
      {
        title: "Payment Terms",
        items: [
          {
            label: {
              value: "Discount Percent",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "discountPcnt"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Discount Days",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "discountDays"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Net Days",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "netDays"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "No. of Payments",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "numPayments"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Day of Month",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "dayMonth"
            },
            size: "calc(100% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "No. of Months",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "numOfMonths"
            },
            size: "calc(100% / 3)",
            readOnly: true
          }
        ]
      },
      {
        title: "card3",
        hideTitle: true,
        items: this.table
      },
      {
        title: "BackHaul Pickup Info",
        items: [
          {
            label: {
              value: "Name",
              size: "calc(100% / 3 * .55)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupName"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Address",
              size: "25%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupAddress"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "City",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupCity"
            },
            size: "calc(50% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "State",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupState"
            },
            size: "calc(50% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Zip",
              size: "55%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupZip"
            },
            size: "calc(50% / 3)",
            readOnly: true
          },
          {
            label: {
              value: "Contact",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupContact"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Phone",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupPhone"
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Hours",
              size: "calc(100% / 3 * .55)"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pickupHours"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "PO Note",
              size: "25%"
            },
            item: {
              node: "input",
              type: "string",
              // onBlur: "",
              value: "",
              intemName: "pONote"
            },
            size: "50%",
            readOnly: true
          }
        ]
      }
    ];
  }

  buildTableTitle = () => {
    const titles = ["Recpt Dt", "Days", "LTU"];
    for (let i = 1; i < 5; i++) {
      for (let x = 1; x < 4; x++) {
        this.table.push({
          label: {
            value: ""
          },
          span: {
            value: titles[x - 1],
            alignment: "center",
            size: "100%"
          },
          item: {
            node: "onlySpan",
            value: "",
            intemName: `grp${i}ttl${x}`
          },
          size: x === 1 ? "12.5%" : "6.25%"
        });
      }
    }
  };
  buildTable = () => {
    const outputs = [
      "ordRecvdDate1",
      "ordSkupLtu1",
      "ordSupplyRecvd1",
      "ordRecvdDate2",
      "ordSkupLtu2",
      "ordSupplyRecvd2",
      "ordRecvdDate3",
      "ordSkupLtu3",
      "ordSupplyRecvd3",
      "ordRecvdDate4",
      "ordSkupLtu4",
      "ordSupplyRecvd4",
      "ordRecvdDate5",
      "ordSkupLtu5",
      "ordSupplyRecvd5",
      "ordRecvdDate6",
      "ordSkupLtu6",
      "ordSupplyRecvd6",
      "ordRecvdDate7",
      "ordSkupLtu7",
      "ordSupplyRecvd7",
      "ordRecvdDate8",
      "ordSkupLtu8",
      "ordSupplyRecvd8",
      "ordRecvdDate9",
      "ordSkupLtu9",
      "ordSupplyRecvd9",
      "ordRecvdDate10",
      "ordSkupLtu10",
      "ordSupplyRecvd10",
      "ordRecvdDate11",
      "ordSkupLtu11",
      "ordSupplyRecvd11",
      "ordRecvdDate12",
      "ordSkupLtu12",
      "ordSupplyRecvd12"
    ];
    var count = 0;
    for (let row = 1; row < 4; row++) {
      for (let i = 1; i < 5; i++) {
        for (let x = 1; x < 4; x++) {
          this.table.push({
            label: {
              value: ` . `,
              align: "center",
              fontSize: x === 1 ? "80%" : "100%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              noInput: true,
              intemName: outputs[count]
            },
            size: x === 1 ? "13%" : "6%",
            readOnly: true
          });
          count++;
        }
      }
    }
  };

  componentDidMount() {
    this.buildTableTitle();
    this.buildTable();
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value = props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <Fragment>
        <div style={{ flex: 1 }}>
          <div style={{ flex: 1, display: "flex" }}>
            <div style={{ flex: 1 }}>
              <InputCard
                jsonObj={this.cardsLayout[0]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <InputCard
                jsonObj={this.cardsLayout[1]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
              <InputCard
                jsonObj={this.cardsLayout[2]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
              <InputCard
                jsonObj={this.cardsLayout[3]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  getTheJson = () => {
    for (let index = 0; index < this.cardsLayout.length; index++) {
      for (let i = 0; i < this.cardsLayout[index].items.length; i++) {
    
      }
    }
  };

  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
